<template>
    <div class="container">
        <div class="row">
            <div class="col-12 text-center py-10">
                <h1 class="mb-5">Link non valido</h1>
                <router-link :to="{ name: 'checkins-list'}" class="btn btn-primary">Vai ai tuoi eventi</router-link>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: "CheckinConfirm"
    }
</script>
